var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNpHexagonPattern940356000000(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100pt",
    height: "100pt",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m66 49l-8.3008-14.301 8.3008-14.301h16.602l8.2969 14.301-8.2969 14.301h-16.602"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m66 79.699l-8.3008-14.301 8.3008-14.398h16.602l8.2969 14.398-8.2969 14.301h-16.602"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m40.602 31.801l-7.1016-12.402 7.1016-12.398h14.297l7.2031 12.398-7.2031 12.402h-14.297"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m40.602 62.398l-7.1016-12.398 7.1016-12.301h14.297l7.2031 12.301-7.2031 12.398h-14.297"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m40.602 93.102l-7.1016-12.402 7.1016-12.398h14.297l7.2031 12.398-7.2031 12.402h-14.297"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.199 45.102l-6-10.402 6-10.398h12l6 10.398-6 10.402h-12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.1992 65.398l6-10.5h12l6 10.5-6 10.402h-12l-6-10.402"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m66 49l-8.3008-14.301 8.3008-14.301h16.602l8.2969 14.301-8.2969 14.301h-16.602"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m66 79.699l-8.3008-14.301 8.3008-14.398h16.602l8.2969 14.398-8.2969 14.301h-16.602"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m40.602 31.801l-7.1016-12.402 7.1016-12.398h14.297l7.2031 12.398-7.2031 12.402h-14.297"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m40.602 62.398l-7.1016-12.398 7.1016-12.301h14.297l7.2031 12.301-7.2031 12.398h-14.297"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m40.602 93.102l-7.1016-12.402 7.1016-12.398h14.297l7.2031 12.398-7.2031 12.402h-14.297"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.199 45.102l-6-10.402 6-10.398h12l6 10.398-6 10.402h-12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.1992 65.398l6-10.5h12l6 10.5-6 10.402h-12l-6-10.402"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNpHexagonPattern940356000000);
export default __webpack_public_path__ + "static/media/np_hexagon-pattern_940356_000000.59131b6b8fbeca4c4304bdca6fefc297.svg";
export { ForwardRef as ReactComponent };